import React, {useCallback, useMemo, useRef, useState} from 'react';

import AllOrders from './allOrders';
import {Buyer} from '@buncha/driver/types/common';
import {DriverOrdersTab} from '../../../../../src/driver/types/driverOrders';
import {HomeScreens} from '@buncha/home/navigation/types';
import {Modules} from '@buncha/utils/types';
import RunOrders from './runOrders';
import {StyleSheet} from 'react-native';
import Tab from '../../../../../src/components/composites/Tabs/Tab';
import {TabData} from '../../../../../src/components/composites/Tabs/type';
import TabHeaderNode from './tabHeaderNode';
import {useGetLocale} from '@buncha/localization/hooks';
import {useRoute} from '@react-navigation/native';

export interface RouteParamsType {
  runId?: number;
  storeId?: number;
  backPage?: HomeScreens;
}

interface Props {
  updateUsersData: (users: Buyer[]) => void;
}

const DriverTabs: React.FC<Props> = props => {
  const route = useRoute();
  const routeParams: RouteParamsType | undefined = route?.params;
  const runId = Number(routeParams?.runId) || 0;
  const keyRef = useRef('');
  const tabHeader = [DriverOrdersTab.RunOrders, DriverOrdersTab.AllOrders];
  const sections: {[key: string]: React.ReactElement} = {};
  const {body} = useGetLocale(Modules.driver, HomeScreens.Driver) ?? {};
  const tabNode = useCallback((info: TabData<any>, activeKey: string) => {
    return <TabHeaderNode info={info} activeKey={activeKey} />;
  }, []);

  const [loading, setLoading] = useState(false);

  const [ordersCount, setOrdersCount] = useState(0);

  tabHeader.forEach(tab => {
    switch (tab) {
      case DriverOrdersTab.RunOrders:
        sections[tab] = (
          <RunOrders
            updateUsersData={props.updateUsersData}
            runId={runId}
            setOrdersCount={setOrdersCount}
            setLoading={setLoading}
          />
        );
        break;
      case DriverOrdersTab.AllOrders:
        sections[tab] = (
          <AllOrders updateUsersData={props.updateUsersData} runId={runId} />
        );
        break;
      default:
        sections[DriverOrdersTab.RunOrders] = (
          <RunOrders
            updateUsersData={props.updateUsersData}
            runId={runId}
            setOrdersCount={setOrdersCount}
          />
        );
    }
  });

  const tabTitle = useMemo(() => {
    if (ordersCount) return `${body?.pendingDeliveries}(${ordersCount})`;
    else if (loading) return body?.loading;
    return body?.pendingDeliveries;
  }, [body?.loading, body?.pendingDeliveries, loading, ordersCount]);

  const tabData = useMemo(() => {
    const tabs = [
      {
        key: DriverOrdersTab.RunOrders,
        data: tabTitle,
      },
    ];
    if (runId)
      tabs.push({
        key: DriverOrdersTab.AllOrders,
        data: 'Delivered',
      });

    return tabs;
  }, [runId, tabTitle]);

  return (
    <Tab
      key={keyRef.current}
      tabData={tabData}
      tabNode={tabNode}
      sections={sections}
      scrollEnabled={false}
      style={styles.tab}
    />
  );
};

export default React.memo(DriverTabs);

const styles = StyleSheet.create({
  tab: {
    marginBottom: 5,
  },
});
